const initialState = {
    reportsByGroups: [],
    reportFieldMappings: {
        mappedDataDictionary: [], unMappedDataDictionary: [], reconFieldMappings: [],
    },
    reportReconFieldMaps: [],
    reportReconFieldExpressions: [],
    clonedMappedDict: [],
    reconFieldColumnNames: [],
    reportMappings: [],
    reportsByGroupsSingle: []
};
export default initialState;